<template>
  <div class="bg-light border rounded-3 p-3">
    <h6>Hitra izbira objekta</h6>
    <p class="text-muted small mb-2">
      Vpiši <strong>šifro naprave</strong> z QR kode naprave (npr. SAM-170477) - stranka in objekt se izpolnita sama.
    </p>
    <div class="input-group">
      <input
        class="form-control"
        v-model="ident"
        :placeholder="placeholder"
        :disabled="disabled"
        @keyup.enter="findAsync"
      />
      <button
        class="btn btn-outline-secondary"
        type="button"
        @click="findAsync"
        :disabled="disabled || !ident || searching"
      >
        Poišči
      </button>
    </div>
    <slot name="hint" />
  </div>
</template>

<script setup>
import { ref } from "vue"
import { searchDevicesAsync } from "../api"
import { useAuth } from "../composition-api/useAuth"

defineOptions({ name: "DeviceNumberSearch" })

defineProps({
  placeholder: { type: String, default: "SAM-170477" },
  disabled: { type: Boolean, default: false },
})

// select(device) - the device the typed/scanned number belongs to; the host reads its customer
// and facility off it (the number is how a caller names the object the call is about)
// not-found(ident) - the search came back empty; a failed search is reported by api.js and
// emits nothing, so the host can keep its message honest
const emit = defineEmits(["select", "not-found"])

const { fetchAuthAsync } = useAuth()

const ident = ref("")
const searching = ref(false)

// The unique device number (SAM-...) is printed as the QR code on the device card - the caller
// reads it out. The sticker "oznaka" (Label) is accepted too, and when neither matches exactly
// the search's own first hit is the best we have (the backend already ranked them).
const pick = (found, wanted) =>
  found.find((d) => (d.deviceNumber || "").toLowerCase() === wanted) ||
  found.find((d) => (d.label || "").toLowerCase() === wanted) ||
  found[0]

const findAsync = async () => {
  const wanted = (ident.value || "").trim()
  if (!wanted || searching.value) return
  searching.value = true
  try {
    const found = await searchDevicesAsync(fetchAuthAsync, wanted)
    // null = the search itself failed (api.js has already shown the error)
    if (!found) return
    if (!found.length) {
      emit("not-found", wanted)
      return
    }
    emit("select", pick(found, wanted.toLowerCase()))
  } finally {
    searching.value = false
  }
}
</script>
